import React from "react";
import { Checkbox, FormControlLabel, FormGroup, FormHelperText } from "@mui/material";

const CheckBox = (props) => {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        handleChange,
        ddTypeCodMngr
    } = props;

    const handleCheckBoxChecked = ({ target: input }) => {
        if (!input.checked) {
            input.value = "";
        }
        handleChange(input);
    };

    const getCheckboxCodeManager = (id) => {
        if (ddTypeCodMngr) {
            const ddType = ddTypeCodMngr.filter((x) => x.controlId === id);
            if (ddType.length > 0) return ddType[0].optionData;
        }
        return [];
    };

    const chkCodemanager = getCheckboxCodeManager(controleId);

    return (
        <FormGroup>
            {chkCodemanager.length > 0 ? (
                chkCodemanager.map((item, key) => {
                    const inputId = `${controleId}${key}`;
                    return (
                        <div key={inputId}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id={inputId}
                                        name={inputId}
                                        value={item.name}
                                        checked={data[inputId] === item.name}
                                        onChange={handleCheckBoxChecked}
                                        disabled={isDisabled}
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#1e293b !important",
                                                color: "#1e293b !important",
                                                opacity: 1,
                                            },
                                            "& .MuiInputLabel-root.Mui-disabled": {
                                                color: "#1e293b !important",
                                                opacity: 1,
                                            },
                                            "&.Mui-disabled": {
                                                color: "#64748b !important",
                                                cursor: "not-allowed",
                                            },
                                            "&.Mui-disabled.Mui-checked": {
                                                color: "#0f172a !important",
                                            },
                                        }}
                                    />
                                }
                                label={
                                    <>
                                        {comp.isRequired && (
                                            <span
                                                style={{
                                                    color: "#000000",
                                                    fontSize: "14px",
                                                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                                                    fontWeight: 400,
                                                    marginRight: 4
                                                }}>*</span>
                                        )}
                                        {item.name}
                                    </>
                                }
                            />
                            {errors[inputId] && (
                                <FormHelperText error>{errors[inputId]}</FormHelperText>
                            )}
                        </div>
                    );
                })
            ) : (
                <div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id={controleId}
                                name={controleId}
                                value="Yes"
                                checked={data[controleId] === "Yes"}
                                onChange={handleCheckBoxChecked}
                                disabled={isDisabled}
                                size="small"
                                sx={{
                                    "& .MuiInputBase-input.Mui-disabled": {
                                        WebkitTextFillColor: "#1e293b !important",
                                        color: "#1e293b !important",
                                        opacity: 1,
                                    },
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                        color: "#1e293b !important",
                                        opacity: 1,
                                    },
                                    "&.Mui-disabled": {
                                        color: "#64748b !important",
                                        cursor: "not-allowed",
                                    },
                                    "&.Mui-disabled.Mui-checked": {
                                        color: "#0f172a !important",
                                    },
                                }}
                            />
                        }
                        label={
                            <>
                                {comp.isRequired && (
                                    <span
                                        style={{
                                            color: "#000000",
                                            fontSize: "14px",
                                            fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                                            fontWeight: 400,
                                            marginRight: 4
                                        }}>*</span>
                                )}
                                {comp.label}
                            </>
                        }
                    />
                    {errors[controleId] && (
                        <FormHelperText error>{errors[controleId]}</FormHelperText>
                    )}
                </div>
            )}
        </FormGroup>
    );
};

export default CheckBox;
